import { Link as LinkReactRouter, LinkProps } from 'react-router';
import { SoundSE, useSounds } from '@outdoria/ui';

export const Link = (props: LinkProps) => {
  const { playSound } = useSounds(undefined);

  const onClick = () => {
    playSound(SoundSE.CLICK);
  };

  return <LinkReactRouter onClick={onClick} {...props} />;
};
